import * as React from 'react';
import { motion } from 'motion/react';

export type AnimateProps = { children: React.ReactElement };

// import { Grow } from '@mui/material';
// export const AnimateUI: React.FC<AnimateProps> = ({ children }) => {
//   const ref = React.useRef<any>();
//   return (
//     <Grow ref={ref.current} in={true} mountOnEnter unmountOnExit>
//       <div ref={ref}>{children}</div>
//     </Grow>
//   );
// };

export const AnimateUI: React.FC<AnimateProps> = ({ children }) => {
  return (
    <motion.div
      animate={{ opacity: 1, rotate: [0, 10, -10, 0] }}
      transition={{ repeat: Infinity, duration: 2 }}
    >
      {children}
    </motion.div>
  );
};
